import React from 'react';
import { GenericReportingDropdowns } from '../../containers/GenericReportingDropdowns';
import DropdownContainer from '../../containers/DropdownContainer';
import { useSelector } from 'react-redux';

const SiteAnalyticsPageDropdowns = () => {

  const startDate = useSelector(state => state.genericReporting.selectedDropdownValues['start_date']);
  const endDate = useSelector(state => state.genericReporting.selectedDropdownValues['end_date']);

    return (
        <GenericReportingDropdowns
          includeDateRange={true}
          includeGranularity={true}
          includeTooltipsAndTitles={false}
          containerStyle="dropdown-container"
          includeCompareDateRange={true}
          renderAsButton={true}
          extraDropdowns={[<DropdownContainer dropdown_name="selected_channel_groups" extraApiParams={{'start_date': startDate, 'end_date': endDate}} />]}
        />
    );
};

export default SiteAnalyticsPageDropdowns;